<template>
    <component
        :is="componentType"
        :type="buttonType"
        :href="url"
        class="group appearance-none rounded font-bold bg-primary text-white shadow-lg relative overflow-hidden flex py-3 px-6 duration-300 transition-opacity"
        :class="{
            'inline-flex': !block,
            'flex w-full': block,
        }"
    >
        <span class="absolute left-0 top-0 bg-gradient-to-r from-primary to-secondary h-full w-full opacity-100 group-hover:opacity-50 duration-300 transition-opacity">
        </span>
        <span class="relative z-10 w-full">
            <slot />
        </span>
    </component>
</template>

<script>
import {Link} from "@inertiajs/inertia-vue3";

export default {
    name: "FancyButton",
    props: {
        type: {
            type: String,
            default: 'button',
            validator(value) {
                return ['button', 'a', 'link'].indexOf(value) !== -1;
            }
        },
        submit: Boolean,
        block: Boolean,
        href: String,
    },
    computed: {
        url () {
            if (this.type === 'button') {
                return null;
            }

            return this.href;
        },
        componentType () {
            if (this.type === 'link') {
                return Link;
            }

            return this.type;
        },
        buttonType () {
            return this.type === 'button' && this.submit
                ? 'submit'
                : 'button';
        }
    }
}
</script>

<style scoped>

</style>
